const widthBreakPoint = 700;

export const responsiveLayout = {
  underWidthBreakPoint: `@container activityHistoryContainer (max-width: ${widthBreakPoint}px)`,
};